import { db } from '@/firebase';
import { doc, getDoc } from 'firebase/firestore';

export async function getUser(id) {
  const docSnap = await getDoc(doc(db, 'users', id));
  if (!docSnap.exists()) return null;
  return docSnap.data();
}
